<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>产品设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="productTypeFilterText">
          </el-input>
          <el-tree
            :data="productTypeList"
            :props="productTypeProps"
            @node-click="productTypeHandleNodeClick"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="productTypeFilterNode"
            default-expand-all
            ref="productTree"
            draggable
            @node-drop="handleDrop"
            :allow-drop="allowDrop">
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
          <el-button size="mini" plain  @click="showProductTypeDialog(1)"
                     v-if="authorities.includes('system.product.type.new')">添加产品分类</el-button>
          <el-button size="mini" plain  @click="showProductTypeDialog(2)"
                     v-if="authorities.includes('system.product.type.update')">修改产品分类</el-button>
          <el-button size="mini" plain  @click="deletePropertyTypeBox"
                     v-if="authorities.includes('system.product.type.delete')">删除产品分类</el-button>
          <el-button size="mini" plain  @click="showProductDialog(1,null)"
                     v-if="authorities.includes('system.product.new')">添加产品</el-button>
        <el-table height="550px" :data="productList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}" >
          <el-table-column
            align="center"
            prop="userName"
            fixed="fixed"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="primary" v-if="authorities.includes('system.product.update')" icon="el-icon-edit"
                       style="padding-right: 10px" @click="showProductDialog(2,scope.row)"></el-link>
              <el-link type="danger" v-if="authorities.includes('system.product.delete')" icon="el-icon-delete"
                       style="padding-left: 10px" @click="deleteProductBox(scope.row)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="productName"
            label="产品名称" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="productTypeName"
            label="产品分类" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="productNo"
            label="产品编号" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="retailPrice"
            label="零售价" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="oneLevelPrice"
            label="1级价" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="twoLevelPrice"
            label="1.5级价" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="threeLevelPrice"
            label="2级价" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="psm"
            label="规格型号" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="unit"
            label="单位" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="barCode"
            label="条码" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="productRate"
            label="提成" width="100">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加分类 -->
    <el-dialog
      :title="title"
      :visible.sync="productTypeDialogVisible"
      width="30%"
      style="position: absolute"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <span>
        产品名称：
        <el-input v-model="productType.productTypeName" placeholder="请输入内容" size="mini" style="width: 300px;padding-bottom: 10px"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancel">取 消</el-button>
            <el-button size="mini" @click="createProductType">确 定</el-button>
          </span>
    </el-dialog>

    <!--  添加产品 -->
    <el-dialog
      :title="product_title"
      :visible.sync="productDialogVisible"
      width="60%"
      @close="closeServiceDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 300px;padding: 10px 0;display: flex;flex-wrap: wrap; align-items: baseline;">
        <div class="input_item_con" style="display: flex;align-items: baseline;justify-content: flex-start;width: 50%;">
          <span>产品名称：</span>
          <el-input v-model="product.productName" @change="checkProductName" placeholder="请输入内容" size="mini" style="width: 300px"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          所属分类：
          <el-input v-model="product.productTypeName"  placeholder="请输入内容" disabled size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          产品编号：
          <el-input v-model="product.productNo"  placeholder="请输入内容" size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          规格型号：
          <el-input v-model="product.psm"  placeholder="请输入内容" size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：
          <el-input v-model="product.unit"  placeholder="请输入内容" size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          条&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：
          <el-input v-model="product.barCode"  placeholder="请输入内容" size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          零&nbsp;售&nbsp;&nbsp;价：<el-input v-model="product.retailPrice" placeholder="请输入内容" size="mini" style="width: 300px;"
                                          onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          <span v-if="priceName === true">采购价格：</span>
          <span v-if="priceName === false">1&nbsp;&nbsp;级&nbsp;&nbsp;价：</span>
          <el-input v-model="product.oneLevelPrice" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          1.5&nbsp;&nbsp;级价：
          <el-input v-model="product.twoLevelPrice" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          2&nbsp;  级&nbsp;&nbsp;价：
          <el-input v-model="product.threeLevelPrice" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          提成（%）：
          <el-input v-model="product.productRate" placeholder="请输入内容" size="mini" style="width: 285px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;">
          是否销售：
          <el-radio-group v-model="product.isSale" @change="getIsSale">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="productCancel">取 消</el-button>
        <el-button size="mini" @click="createProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      orgLevel:'',
      authorities:'',
      userId: '',
      //##########组织机构部分##########
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      //###########产品分类部分###########
      productTypeFilterText:'',
      productTypeList:[],
      productTypeProps:{
        label: 'productTypeName',
        children: 'children'
      },
      isShow: true,
      isShow_:true,

      loadProductTypeOrgId:'',
      title:'',
      productTypeDialogVisible: false,
      productType:{
        id:'',
        orgIds:[],
        productTypeName:'',
        parentId:'',
        parentTypeName:'',
        orderNo:'',
        creator:'',
        modifier:''
      },
      operateType:'',
      productTypeData:'',
      //######################以下是服务的内容
      product_title:'',
      productList:[],
      productDialogVisible:false,
      product:{
        id:'',
        orgId:'',
        orgIds:[],
        productName:'',
        oldProductName:'',
        productNo:'',
        psm:'',
        unit:'',
        barCode:'',
        retailPrice:'',
        oneLevelPrice:'',
        twoLevelPrice:'',
        threeLevelPrice:'',
        productRate:'',
        productTypeId:'',
        productTypeName: '',
        creator: '',
        modifier:'',
        isSale:''
      },
      productIsDisplay:true,
      productOperateType:'',
      deleteProductId:'',
      deleteProductName:'',
      loadProductOrgId:'',
      loadProductsTypeId:'',
      oldProductTypeName:'',
      existName:false,
      createProductTypeDoubleClick:false,
      priceName:false,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    productTypeFilterText(val) {
      this.$refs.productTree.filter(val);
    }
  },
  methods:{
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },

    //组织机构树点击节点方法
    async handleCheckChange(data) {
      this.isShow = true;
      this.isShow_ = true;
      this.loadProductTypeOrgId = data.id;
      this.orgLevel = data.level;
      this.orgId = data.id;
      this.productType.orgIds = this.$refs.tree.getCheckedKeys();
      this.product.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.productType.orgIds.length === 0){
        this.productTypeList = [];
      }
      if (this.productType.orgIds.length > 0){
        //加载产品分类
        const {data:res} = await this.$http.get(`productType/orgId/${this.productType.orgIds[0]}`);
        if (res.code === 200){
          this.productTypeList = res.data;
        }
      }
    },
    closeServiceDialog(){
      this.productDialogVisible = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    productTypeFilterNode(value, data) {
      if (!value) return true;
      return data.productTypeName.indexOf(value) !== -1;
    },
    async productTypeHandleNodeClick(data){
      this.isShow = false;
      if (this.operateType === 1){
        this.productType.parentId = data.id;
        this.productType.parentTypeName = data.productTypeName;
      }
      this.productTypeData = data;
      this.oldProductTypeName = data.productTypeName;
      if (data.parentId !== '' && data.parentId !== 0 || data.productTypeName === '自采产品'){
        this.isShow = true;
        this.productIsDisplay = false;
      } else {
        this.productIsDisplay = true;
      }

      if (data.productTypeName === '自采产品'){
        this.priceName = true;
      } else {
        this.priceName = false;
      }

      await this.loadProduct();
    },

    //显示添加产品分类的方法
    async showProductTypeDialog(val){
      this.operateType = val;
      if (val === 1){
        this.title = "添加产品分类";
      } else {
        this.title = "修改产品分类";
        this.productType.id = this.productTypeData.id;
        this.productType.orgId = this.productTypeData.orgId;
        this.productType.productTypeName = this.productTypeData.productTypeName;
        this.productType.orderNo = this.productTypeData.orderNo;
      }
      this.productTypeDialogVisible = true;
    },
    cancel(){
      this.productTypeDialogVisible = false;
    },
    async createProductType(){

      if (this.operateType === 1){
        if (this.productType.productTypeName === ''){
          return this.$message.warning("请填写产品名称！");
        }
        if (this.productType.orgIds === '' || this.productType.orgIds.length ===0){
          return this.$message.warning("请勾选机构！");
        }
        const {data:res1} = await this.$http.get(`/productType/name/${this.productType.productTypeName}`);
        if (res1.code === 200){
          return this.$message.warning("该分类名称已经存在！")
        }
        //新增产品分类
        this.productType.creator = this.userId;
        this.createProductTypeDoubleClick= true;
        const {data:res} = await this.$http.post(`productType`,this.productType);
        if (res.code === 200){
          this.productTypeList = res.data;
          this.createProductTypeDoubleClick= false;
        } else {
          this.createProductTypeDoubleClick= false;
        }
      }
      if (this.operateType === 2){
        if (this.productType.productTypeName === ''){
          return this.$message.warning("请填写产品分类名称！");
        }
        //更新产品分类
        this.productType.modifier = this.userId;
        const {data:res1} = await this.$http.get(`/productType/name/${this.productType.productTypeName}`);
        if (res1.code === 200){
          return this.$message.warning("该分类名称已经存在！")
        }
        this.createProductTypeDoubleClick= true;
        const {data:res} = await this.$http.put(`/productType/orgId/${this.orgId}/newProductTypeName/${this.productType.productTypeName}/oldProductTypeName/${this.oldProductTypeName}/modifier/${this.userId}`);
        if (res.code === 200){
          this.productTypeList = res.data;
          this.createProductTypeDoubleClick= false;
        } else {
          this.createProductTypeDoubleClick= false;
        }
      }
      this.clear();
      this.productTypeDialogVisible = false;
    },
    deletePropertyTypeBox(){
      this.$confirm('此操作将永久删除该分类, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteProductType();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteProductType(){
      //删除产品分类
      const {data:res} = await this.$http.delete(`/productType/orgId/${this.productTypeData.orgId}/orgLevel/${this.orgLevel}/productTypeName/${this.productTypeData.productTypeName}`);
      if (res.code === 200){
        this.$message.success(res.msg);
        this.productTypeList = res.data;
      } else {
        this.$message.success(res.msg);
      }
    },
    closeDialog(){
      this.clear();
    },
    clear(){
      this.productTypeDialogVisible = false;
      this.productType.productTypeName = '';
      this.productType.orderNo = '';
    },
    showProductDialog(val, data){
      this.productOperateType = val;
      if (val === 1){
        this.product_title = '添加产品';
        this.product.productTypeName = this.productTypeData.productTypeName;
        this.product.productTypeId = this.productTypeData.id;
        // this.product.orgId = this.productTypeData.orgId;
        this.product.creator = this.userId;
        this.product.productName = this.productTypeData.productName;
        this.product.productNo = this.productTypeData.productNo;
        this.product.psm = this.productTypeData.psm;
        this.product.unit = this.productTypeData.unit;
        this.product.barCode = this.productTypeData.barCode;
        this.product.retailPrice = this.productTypeData.retailPrice
        this.product.oneLevelPrice = this.productTypeData.oneLevelPrice;
        this.product.twoLevelPrice = this.productTypeData.twoLevelPrice;
        this.product.threeLevelPrice = this.productTypeData.threeLevelPrice;
        this.product.productRate = this.productTypeData.productRate;
      } else {
        this.product_title = '修改产品';
        this.product.productTypeName = data.productTypeName;
        this.product.productTypeId = data.productTypeId;
        this.product.orgId = data.orgId;
        this.product.productNo = data.productNo;
        this.product.psm = data.psm;
        this.product.unit = data.unit;
        this.product.barCode = data.barCode;
        this.product.retailPrice = data.retailPrice
        this.product.oneLevelPrice = data.oneLevelPrice;
        this.product.twoLevelPrice = data.twoLevelPrice;
        this.product.threeLevelPrice = data.threeLevelPrice;
        this.product.productRate = data.productRate;
        this.product.productName = data.productName;
        this.product.id = data.id;
        this.product.modifier = this.userId;
        this.product.oldProductName = data.productName;
        this.product.isSale = data.isSale;
      }
      this.productDialogVisible = true;
    },
    async createProduct(){

      if (this.existName === true){
        return this.$message.warning("该产品名称已经存在！")
      }
      //新增产品
      if (this.productOperateType === 1){
        this.createProductDoubleClick = true;
        const {data:res} = await this.$http.post(`product`,this.product);
        if (res.code === 200){
          this.$message.success(res.msg);
          this.createProductDoubleClick = false;
        } else {
          this.createProductDoubleClick = false;
        }
      } else {
        //更新产品
        this.createProductDoubleClick = true;
        const {data:res} = await this.$http.put(`/product/orgId/${this.orgId}/orgLevel/${this.orgLevel}`,this.product);
        if (res.code === 200){
          this.$message.success(res.msg);
          this.createProductDoubleClick = false;
        } else {
          this.createProductDoubleClick = false;
        }
      }
      setTimeout(() =>{
          this.doubleClick = false;
        },5000
      )
      await this.loadProduct();
      this.productDialogVisible = false;
    },
    productCancel(){
      this.productDialogVisible = false;
    },
    deleteProductBox(data){
      this.deleteProductId = data.id;
      this.deleteProductName = data.productName;
      this.loadProductOrgId = data.orgId;
      this.loadProductsTypeId = data.productTypeId;
      this.$confirm('此操作将永久删除该分类, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteProduct();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteProduct(){
      //删除产品
      const {data:res} = await this.$http.delete(`/product/productName/${this.deleteProductName}/typeId/${this.loadProductsTypeId}/orgId/${this.orgId}/orgLevel/${this.orgLevel}`);
      if (res.code === 200){
        this.$message.success(res.msg);
        this.productList = res.data;
      } else {
        this.$message.success(res.msg);
      }
    },
    async loadProduct(){
      const {data:res} = await this.$http.get(`product/productTypeId/${this.productTypeData.id}/orgId/${this.productTypeData.orgId}`);
      if (res.code === 200){
        this.productList = res.data;
      }
    },
    //拖拽保存方法
    async handleDrop(draggingNode, dropNode, dropType){
      const paramData = [];
      // 当拖拽类型不为inner,说明只是同级或者跨级排序，只需要寻找目标节点的父ID，获取其对象以及所有的子节点，并为子节点设置当前对象的ID为父ID即可
      // 当拖拽类型为inner，说明拖拽节点成为了目标节点的子节点，只需要获取目标节点对象即可
      const data = dropType !== "inner" ? dropNode.parent.data : dropNode.data;
      const nodeData = dropNode.level === 1 && dropType !== "inner" ? data : data.children;
      // 设置父ID,当level为1说明在第一级，pid为空
      nodeData.forEach(element => {
        element.pid = dropNode.level === 1 ? "" : data.id;
      });
      nodeData.forEach((element, i) => {
        const dept = {
          deptId: element.id,
          parentDeptId: element.pid,
          order: i
        };
        paramData.push(dept);
      });

      // 得到这次操作需要变更的数据范围，请求后台批量处理即可...
      const {data:res} =  await this.$http.put(`productType/productTypeListOrder/orgId/${this.productTypeData.orgId}/orgLevel/${this.orgLevel}`, paramData);
      if (res.code === 200){
        this.productTypeList = res.data;
      }
    },
    allowDrop(moveNode, inNode, type) {
      if(moveNode.level=== 1 && inNode.level===1){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        } else {
          return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 2 && inNode.level === 2 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        }else{
          return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 3 && inNode.level === 3 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        }else{
          return type === 'next';
        }
      }
    },
    getIsSale(value){
      this.product.isSale = value;
    },
    async checkProductName(){
      const {data:res} =  await this.$http.get(`product/checkName/${this.product.productName}`);
      if (res.data > 0){
        this.$message.warning("该产品已经存在！");
        this.existName = true;
      } else {
        this.existName = false;
      }
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 100vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  width: 30%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 70%;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue